const spaceIds = {
  local: 1587726129258720,
  dev: 1587726129258720,
  test: 1730698302063648,
  pre: 1870778447251296,
  prod: 1870778447251296,
}

const getSpaceId = (env) => {
  return spaceIds[env]
}

const queryOptions = {
  // 后期版本升级，softwareVersion可能会有变化
  gac: {
    platformCode: 'GENERAL',
    softwareCode: 'bimmake',
  },
  skp: {
    platformCode: 'GENERAL',
    softwareCode: 'sketchup',
    softwareVersion: '2017',
  }
}
const getQueryFilters = (suffix) => {
  return queryOptions[suffix]
}

export default { getSpaceId, getQueryFilters }
